import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { settings } from "src/app/shared/settings/config";
import { Observable, of } from "rxjs";
import { CategoriesEnt } from "src/app/shared/models/Category";
import { map } from "rxjs/operators";
import { nullSafeIsEquivalent } from "@angular/compiler/src/output/output_ast";

@Injectable({
  providedIn: "root",
})
export class CategoryService {
  constructor(private http: HttpClient) {}

  categories(
    countryId: number,
    isEcommerceCategory: boolean,
    isRegisterCategory: boolean,
    isSellerCategory: boolean
  ): Observable<CategoriesEnt[]> {
    let setting: settings = new settings();
    const params = {
      CountryId: countryId.toString(),
      IsEcommerceCategory: isEcommerceCategory.toString(),
      IsRegisterCategory: isRegisterCategory.toString(),
      IsSellerCategory: isSellerCategory.toString(),
    };
    return this.http.get<CategoriesEnt[]>(
      setting.ApiUrl + "api/category/GetCategories",
      { params }
    );
  }

  GetCategoriesByParentId(parentId: number) {
    this.categories(1, true, false, false).subscribe((x: CategoriesEnt[]) => {
      return x.find((e) => e.parentId == parentId);
    });
  }
}
